import styled from '@emotion/styled';

const Heading = styled('h1')`
    width: 100%;
    margin-bottom: 24px;
    color: ${(props)=> props.theme.primaryColor};
    line-height: 40px;    

    font-family: ${(props) => props.theme.fontFamily};
    font-weight: 600;
    font-size: 30px;
    
    @media ${(props)=> props.theme.mobile} {
      font-size: 24px;
      line-height: 32px;  
    }
`;

export default Heading;
